import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger mb-0 text-center"
}
const _hoisted_6 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_7 = { class: "col-md-12 mb-3 mt-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h5", { class: "mb-20 mt-3" }, "Nouveau bon de livraison")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-bell me-2" }, null, -1)),
                  _createElementVNode("span", null, "Vous avez " + _toDisplayString(_ctx.countColis) + " nouveaux colis", 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
          _createElementVNode("hr")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-success",
            disabled: _ctx.countColis === 0 || _ctx.load,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDeliveryNote && _ctx.addDeliveryNote(...args)))
          }, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "flaticon-plus me-2" }, null, -1)),
            (_ctx.load)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                ])))
              : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Ajouter un bon livraison", -1))
          ], 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}